var map = {
	"./poi_SESUnits.svg": 788,
	"./poi_SESUnits_multi.svg": 789,
	"./poi_ambulance.svg": 790,
	"./poi_ambulance_multi.svg": 791,
	"./poi_emergency.svg": 792,
	"./poi_emergency_multi.svg": 793,
	"./poi_fireStation.svg": 794,
	"./poi_fireStationForest.svg": 795,
	"./poi_fireStationForest_multi.svg": 796,
	"./poi_fireStation_multi.svg": 797,
	"./poi_hospital.svg": 798,
	"./poi_hospital_multi.svg": 799,
	"./poi_marker.svg": 800,
	"./poi_marker_multi.svg": 801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 787;